module.exports = require("detect-port-alt");